export const NOT_START = 0
export const IN_PROCESS = 1
export const COMPLETE = 2
export const NOT_FOUND = 3
